<!--
 * @Author: XuXin 2172438065@qq.com
 * @Date: 2024-06-21 08:35:01
 * @LastEditors: XuXin 2172438065@qq.com
 * @LastEditTime: 2024-08-29 14:15:14
 * @FilePath: \high-tech-materialsd:\workCode\xx\youbi\front\CustPC\src\views\preview\iframe\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <pan-simple-header/>
        <div class="iframe-content">
            <iframe class="iframe" :src="showPath" frameborder="0"/>
        </div>
    </div>
</template>

<script>

    import PanSimpleHeader from '../../../components/simple-header'
    import panUtil from '../../../utils/common'

    export default {
        name: "Iframe",
        components: { PanSimpleHeader },
        data() {
            return {
                showPath: ''
            }
        },
        methods: {
            init() {
                let _this = this,
                    fileId = _this.$route.params.ossPathUrl
                _this.showPath = panUtil.getPreviewUrl(ossPathUrl)
            }
        },
        computed: {},
        mounted() {
            this.init()
        }
    }
</script>

<style scoped>

    .iframe-content {
        width: 100%;
        margin-top: 62px;
        display: block;
        text-align: center;
    }

    .iframe {
        width: 100%;
        height: 1200px;
    }

</style>
